import axios from '../utils/axios.js';

const getTailoredResume = async (resumeId, jobId, feature = null, source = null) => {
	const body = {
		resume_uuid: resumeId,
		job_id: jobId,
	};
    
	if (feature != null) {
		body['feature'] = feature;
	}

	if (source != null) {
		body['source'] = source;
	}
    
	return axios.post('/api/resumes/tailor', body);
};

export { getTailoredResume };
